(function () {
    const [...menus] = document.getElementsByClassName('menu_toggler');
    let menuData = [];
    let activeMenuTrigger = null;
    const breakpoints = {
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        xxl: 1400
    };

    function debounce(func, wait) {
        let timeout;
        return function (...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                func.apply(context, args);
            }, wait);
        };
    }

    function calculateLayout() {
        if (menuData.length > 0) {
            menuData.forEach(menu => {
                if (menu.breakpoint) {
                    const isDropdownMode = window.innerWidth < breakpoints[menu.breakpoint];
                    setLinkKeydownHandler(isDropdownMode, menu.dom);
                }
            });
        }
    }

    window.addEventListener('resize', debounce(calculateLayout, 100));

    function setupMenus() {
        if (menus) {
            menus.forEach(menu => {
                menu.addEventListener('click', menuHandler);
                menu.addEventListener('keydown', menuKeyboardHandler);

                const breakpoint = menu.getAttribute('data-breakpoint');
                const menuObj = {
                    dom: menu,
                    breakpoint: breakpoint
                };

                menuData.push(menuObj);

                // Initial setup based on window width
                if (breakpoint) {
                    if (window.innerWidth < breakpoints[breakpoint]) {
                        setLinkKeydownHandler(true, menu);
                    }
                } else {
                    setLinkKeydownHandler(true, menu);
                }
            });
        }
    }

    function setLinkKeydownHandler(add, menu) {
        if (menu) {
            const subMenu = menu.nextElementSibling;
            if (subMenu) {
                if (add) {
                    subMenu.addEventListener('keydown', linkKeydownHandler);
                } else {
                    subMenu.removeEventListener('keydown', linkKeydownHandler);
                }
            }
        }
    }

    function getFirstLink(subMenu) {
        const [...links] = subMenu.getElementsByTagName('a');
        return links[0];
    }

    function getLastLink(subMenu) {
        const [...links] = subMenu.getElementsByTagName('a');
        let lastLink = links[links.length - 1];

        if (lastLink && lastLink.parentNode.hasAttribute('data-breakpoint')) {
            const breakpoint = lastLink.parentNode.getAttribute('data-breakpoint');
            if (window.innerWidth >= breakpoints[breakpoint]) {
                lastLink = links[links.length - 2];
            }
        }
        return lastLink;
    }

    function linkKeydownHandler(e) {
        // Use Event Delegation: check if the event came from an anchor
        if (e.target.tagName !== 'A') return;

        const subMenu = e.currentTarget;
        const firstLink = getFirstLink(subMenu);
        const lastLink = getLastLink(subMenu);

        // On Escape: Close menu and return focus to trigger
        if (e.key === 'Escape') {
            e.preventDefault();
            if (activeMenuTrigger) {
                activeMenuTrigger.focus();
                hideMenu();
            }
        }

        // On Tab: Handle focus trapping (cycling)
        if (e.key === 'Tab') {
            if (e.shiftKey) { // Backward Tab
                if (document.activeElement === firstLink) {
                    e.preventDefault();
                    lastLink.focus();
                }
            } else { // Forward Tab
                if (document.activeElement === lastLink) {
                    e.preventDefault();
                    firstLink.focus();
                }
            }
        }
    }

    function menuKeyboardHandler(event) {
        const subMenu = this.nextElementSibling;
        if (event.key === 'Enter' || event.key === ' ') {
            trapFocus(subMenu);
        }
    }

    function menuHandler() {
        const menuTrigger = this;
        const subMenu = menuTrigger.nextElementSibling;

        if (!activeMenuTrigger) {
            activateMenu(menuTrigger, subMenu);
        } else {
            const previousTrigger = activeMenuTrigger;
            hideMenu();

            if (menuTrigger !== previousTrigger) {
                activateMenu(menuTrigger, subMenu);
            }
        }
    }

    function activateMenu(trigger, subMenu) {
        activeMenuTrigger = trigger;
        trigger.setAttribute('aria-expanded', 'true');
        trigger.classList.add('active');
        subMenu.classList.add('active');
    }

    function trapFocus(element) {
        const links = element.getElementsByTagName('a');
        if (links.length > 0) {
            setTimeout(() => {
                links[0].focus();
            }, 50);
        }
    }

    function hideMenu() {
        if (activeMenuTrigger) {
            activeMenuTrigger.classList.remove('active');
            activeMenuTrigger.nextElementSibling.classList.remove('active');
            activeMenuTrigger.setAttribute('aria-expanded', 'false');
            activeMenuTrigger = null;
        }
    }

    // Close on outside click
    document.addEventListener('click', function (event) {
        if (activeMenuTrigger) {
            if (!activeMenuTrigger.contains(event.target) &&
                !activeMenuTrigger.nextElementSibling.contains(event.target)) {
                hideMenu();
            }
        }
    });

    // Run initialization
    setupMenus();
})();